<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Trucking Company - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col v-if="role==='super_admin' || role==='operations_manager'" lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTC">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTC">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<!-- <b-tab title="Operating Area" active> -->
						<b-row>
							<b-col md="8">

								<b-form-group :label-cols="4" id="L1" label="Company Name" label-for="CompanyNameID" horizontal>
									<b-form-input v-if="!edit" class="plaintext-input"  plaintext id="CompanyNameID" v-model="model.trucking_company_name" type="text"></b-form-input>
									<b-form-input v-if="edit && role==='super_admin'" class="plaintext-input" id="CompanyNameID" v-model="model.trucking_company_name" type="text"></b-form-input>
									<b-form-input  v-if="edit && role==='operations_manager'" class="plaintext-input" plaintext id="CompanyNameID" v-model="model.trucking_company_name" type="text"></b-form-input>
								</b-form-group>

								<b-form-group v-if="role==='super_admin' && model.energy_companies.length > 0 && !edit" :label-cols="4" id="L2" label="Energy Companies" label-for="loadLocationsID" horizontal>
									<b-form-checkbox-group text-field="company_name" class="custom-checkboxes" :options="model.energy_companies" name="Checkboxes2" :checked="true" plain disabled></b-form-checkbox-group>
								</b-form-group>
								<b-form-group  :label-cols="4" id="L177" label="Truck Printing" label-for="ULID0" horizontal>
									<b-form-checkbox v-if="!edit"
                  						id="checkbox"
										class="custom-checkboxes"
                  						v-model="model.in_truck_printing" 
										plain disabled
              						></b-form-checkbox>	
									<b-form-checkbox v-else
                  						id="checkbox"
										class="custom-checkboxes"
										style="margin-top: 13px;"
                  						v-model="model.in_truck_printing" 
              						></b-form-checkbox>
								</b-form-group>	
								<b-form-group  :label-cols="4" id="L17" label="Multi Loads" label-for="ULID" horizontal>
									<b-form-checkbox v-if="!edit"
                  						id="checkbox"
										class="custom-checkboxes"
                  						v-model="model.multiloads" 
										plain disabled
              						></b-form-checkbox>	
									<b-form-checkbox v-if="edit && role==='super_admin'" 
                  						id="checkbox"
										class="custom-checkboxes"
										style="margin-top: 13px;"
                  						v-model="model.multiloads" 
              						></b-form-checkbox>	
									<b-form-checkbox v-if="edit && role==='operations_manager'"
                  						id="checkbox"
										class="custom-checkboxes"
                  						v-model="model.multiloads" 
										plain disabled
              						></b-form-checkbox>
								</b-form-group>	

								<!-- Added by Carlos Rondon 15/02/2019 trucking company -->
								<b-form-group v-if="model.operating_areas.length > 0 && !edit" :label-cols="4" id="L3" label="Operating Areas" label-for="OaID" horizontal>
									<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.operating_areas" name="Checkboxes2"  :checked="true" plain disabled></b-form-checkbox-group>
								</b-form-group>
								<b-form-group v-if="model.load_locations.length > 0 && !edit" :label-cols="4" id="L4" label="Load Locations" label-for="LLID" horizontal>
									<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="model.load_locations" name="Checkboxes2"  :checked="true" plain disabled></b-form-checkbox-group>
								</b-form-group>
								<b-form-group v-if="model.unload_locations.length > 0 && !edit" :label-cols="4" id="L5" label="Unload Locations" label-for="ULID" horizontal>
									<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="model.unload_locations" name="Checkboxes2"  :checked="true" plain disabled></b-form-checkbox-group>
								</b-form-group>
								<!-- End Added -->

								<b-form-group v-if="role==='super_admin' && energycompaniesselect.length > 0 && edit" :label-cols="4" id="L6" label="Energy Company" label-for="energyID" horizontal>
									<b-form-checkbox-group value-field="id" text-field="company_name"  class="custom-checkboxes" :options="energycompaniesselect" name="Checkboxes2" plain v-model="model.energy_company_id" @input="ECChange"></b-form-checkbox-group>
									<b-form-checkbox style="margin-top: 15px;" v-model="ecAllSelected" :indeterminate="indeterminateEC" aria-describedby="" aria-controls="" plain @change="ECToggleAll">
										{{ ecAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group>
								<!-- Added by Carlos Rondon 15/02/2019 trucking company -->
								<b-form-group v-if="operatingareasselect.length > 0 && edit" :label-cols="4" id="L7" label="Operating Areas" label-for="Oa1ID" horizontal>
									<b-form-checkbox-group value-field="id" text-field="name" class="custom-checkboxes" :options="operatingareasselect" name="Checkboxes2" plain v-model="model.operating_areas_id" @input="OAChange"></b-form-checkbox-group>
									<b-form-checkbox style="margin-top: 15px;" v-model="oaAllSelected" :indeterminate="indeterminateOA" aria-describedby="" aria-controls="" plain @change="OAToggleAll">
										{{ oaAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox> 
								</b-form-group>

								<b-form-group v-if="loadlocationsselect.length > 0 && edit" :label-cols="4" id="L8" label="Load Locations" label-for="LL1ID" horizontal>
									<b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="loadlocationsselect" name="Checkboxes2" plain disabled v-model="model.load_locations_id" ></b-form-checkbox-group>
						<!--			<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">@input="LLChange"
										{{ llAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox> -->
								</b-form-group>

								<b-form-group v-if="unloadlocationsselect.length > 0 && edit" :label-cols="4" id="L9" label="Unload Locations" label-for="LL1ID" horizontal>
									<b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="unloadlocationsselect" name="Checkboxes2" plain disabled v-model="model.unload_locations_id" ></b-form-checkbox-group>
						<!--			<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ULToggleAll">@input="ULChange"
										{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox> -->
								</b-form-group>
								<!-- End Added editTC-->
								<b-form-group :label-cols="4" id="L11" label="Address" label-for="address" horizontal>
									<b-form-textarea id="address" v-if="!edit" class="plaintext-input"  plaintext type="text" v-model="model.address" rows="3" max-rows="8"></b-form-textarea>
									<b-form-input id="address" v-else type="text" v-model="model.address"></b-form-input>
								</b-form-group>
								<b-form-group :label-cols="4" id="L12" label="Dispatch Title" label-for="dispatch_title" horizontal>
									<b-form-input id="dispatch_title" v-if="!edit" class="plaintext-input"  plaintext type="text" v-model="model.dispatch_title"></b-form-input>
									<b-form-input id="dispatch_title" v-else type="text" v-model="model.dispatch_title"></b-form-input>
								</b-form-group>
								<b-form-group :label-cols="4" id="L13" label="Phone Number #1" label-for="phone_number1" horizontal>
									<b-form-input id="phone_number1" v-if="!edit" class="plaintext-input"  plaintext type="tel" v-model="model.phone_number1"></b-form-input>
									<b-form-input id="phone_number1" v-else type="tel" v-model="model.phone_number1" placeholder="##########" v-mask="'##########'"></b-form-input>
								</b-form-group>
								<b-form-group :label-cols="4" id="L14" label="Phone Number #2" label-for="phone_number2" horizontal>
									<b-form-input id="phone_number2"  v-if="!edit" class="plaintext-input"  plaintext type="tel" v-model="model.phone_number2"></b-form-input>
									<b-form-input id="phone_number2" v-else type="tel" v-model="model.phone_number2" placeholder="##########" v-mask="'##########'"></b-form-input>
								</b-form-group>
								<b-form-group :label-cols="4" id="L16"  label="Alternate Name" label-for="alternate_name" horizontal>
									<b-form-input id="alternate_name" v-if="!edit" class="plaintext-input"  plaintext type="text" v-model="model.alternate_name"></b-form-input>
									<b-form-input id="alternate_name" v-else type="text" v-model="model.alternate_name"></b-form-input>
            					</b-form-group>
								<b-form-group v-if="!edit" :label-cols="4" id="L17"  label="Company Logo" label-for="company_logo" horizontal>
									<b-form-input id="company_logo" class="plaintext-input"  plaintext type="text" v-model="model.company_logo"></b-form-input>
            					</b-form-group>
								<b-form-group v-else :label-cols="4" id="L17"  label="Company Logo" label-for="company_logo" horizontal>
									<b-form-input id="company_logo" v-if="model.company_logo!=''" class="plaintext-input"  plaintext type="text" v-model="model.company_logo"></b-form-input>
									<input type="file" id="files" accept="image/*" ref="file" v-on:change="handleFileUpload()" />
            					</b-form-group>
			
								<b-form-group  v-if="!edit" :label-cols="4" id="L6" label="Hazards:" label-for="hzID" horizontal>
										<b-form-checkbox-group text-field="hazard_name" class="custom-checkboxes" :options="model.hazard" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
								</b-form-group>	 
								<b-form-group v-else :label-cols="4" id="L6" label="Hazards:" label-for="hzID" horizontal>
									<b-form-checkbox-group v-if="hazards.length > 0" value-field="id" text-field="name"  class="custom-checkboxes" :options="hazards" name="Checkboxes2" plain v-model="model.hazard_id"  @input="HZChange"></b-form-checkbox-group>
									<p v-else>No Hazards have been added</p>
									<b-form-checkbox v-if="hazards.length > 0" style="margin-top: 15px;" v-model="hzAllSelected" :indeterminate="indeterminateHZ" aria-describedby="" aria-controls="" plain @change="HZToggleAll">
										{{ hzAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group>	

								<b-form-group  v-if="!edit" :label-cols="4" id="L7" label="Controls:" label-for="ctlID" horizontal>
										<b-form-checkbox-group text-field="control_name" class="custom-checkboxes" :options="model.control" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
								</b-form-group>						
								<b-form-group v-else :label-cols="4" id="L7" label="Controls:" label-for="ctlID" horizontal>
									<b-form-checkbox-group v-if="controls.length > 0" value-field="id" text-field="name"  class="custom-checkboxes" :options="controls" name="Checkboxes2" plain v-model="model.control_id"  @input="CTLChange"></b-form-checkbox-group>
									<p v-else>No Controls have been added</p>
									<b-form-checkbox v-if="controls.length > 0" style="margin-top: 15px;" v-model="ctlAllSelected" :indeterminate="indeterminateCTL" aria-describedby="" aria-controls="" plain @change="CTLToggleAll">
										{{ ctlAllSelected ? 'Un-select All' : 'Select All' }}
									</b-form-checkbox>
								</b-form-group>						
 
								<div slot="footer" v-show="edit">
									<b-button @click="updateTC" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editTC" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>

							</b-col>
						</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import tc_service from './tc_service'
	export default {
		name: 'truckingCompany',
		created: function() {
			this.getCompanyData()
		},
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		data() {
			return {
				subTitle: '',
				edit: false,
				found: false,
				notFoundMessage: 'Not found',
				energycompaniesselect: [],	
				model: {
					trucking_company_name	: '',
					energy_company_id		: [],
					operating_areas_id		: [],
					load_locations_id		: [],
					unload_locations_id		: [],

					energy_companies 		: [],
					operating_areas 		: [],
					load_locations 			: [],
					unload_locations 		: [],
					multiloads				: false,
					address               : '',
					dispatch_title        : '',
					phone_number1         : '',
					phone_number2         : '',
					company_logo          : '',
					alternate_name        : '',
					in_truck_printing		: false,
					hazard_id   : [],
            		control_id     : [],
					hazard   : [],
            		control     : [],
				},
				indeterminateEC: false,
				ecAllSelected: false,
				updateData: null,
				originalData: null,
				loadingData: true,
				// Added by Carlos Rondon 15/02/2019 trucking company
				operatingareasselect	: [],
				indeterminateOA			: false,
				oaAllSelected			: false,
				operating_areas			: [],

				loadlocationsselect  	: [],	
				unloadlocationsselect 	: [],
				load_locations			: [],
				unload_locations		: [],
				indeterminateLL			: false,
				llAllSelected			: false,
				indeterminateUL			: false,
				ulAllSelected			: false,
				role					: '',
				file                  : '',
        		url                   : '',
				hazard						        : [],
				control					        : [],
				hazards						        : [],
				controls					        : [],
				indeterminateHZ				    : false,
				hzAllSelected				      : false, 
				indeterminateCTL   			  : false,
				ctlAllSelected				    : false, 
				// End Added
			}
		},
		methods: {
			allCheckedEC() {
				//return Array(this.model.energy_companies_check.length).fill(true)
			},
			editTC() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			ECChange() {
        // Added 20/02/2019
        if (this.role==='super_admin') {
            let energy_companies      = this.energycompaniesselect
            let energy_companies_id   = this.model.energy_company_id
            this.loadlocationsselect  = []
            this.operatingareasselect = []
            let new_loadlocations     = []
						let new_oa                = []

						let new_unloadlocations   = []
						this.unloadlocationsselect  = []
            for (var i = 0; i < energy_companies_id.length; i+=1) {
              let energy_company_index = energy_companies.map(o => o.id).indexOf(energy_companies_id[i])
              	if (energy_company_index > -1) {
                  let loadlocations = energy_companies[energy_company_index].loads_locations
                  let operatingarea = energy_companies[energy_company_index].operating_area
                  loadlocations.forEach(function(e){
                    if (new_loadlocations.length != 0) {
                        if (new_loadlocations.map(o => o.id).indexOf(e.id)<0) {
														new_loadlocations.push(e)
												} 
                    } else {
                      			new_loadlocations.push(e)
                    } 
                  })
                  operatingarea.forEach(function(e){
                    if (new_oa.length != 0) {
                        if (new_oa.map(o => o.id).indexOf(e.id)<0) {
														new_oa.push(e)
														new_unloadlocations =  	new_unloadlocations.concat(e.unload_locations)
												} 
                    } else {
												new_oa.push(e)
												new_unloadlocations =  new_unloadlocations.concat(e.unload_locations)
                    } 
				  				})
								} else {
				  					new_loadlocations = []
				  					new_unloadlocations = []
          					new_oa            = []
        				}
        }
          this.loadlocationsselect  	=	new_loadlocations
					this.operatingareasselect 	=	new_oa 
					this.unloadlocationsselect  = this.arrayUnique(new_unloadlocations)
          // End Added
				  if (this.model.energy_company_id.length === 0) {
					  this.indeterminateEC = false
					  this.ecAllSelected = false
				  } else if (this.model.energy_company_id.length === this.energycompaniesselect.length) {
					  this.indeterminateEC = false
					  this.ecAllSelected = true
				  } else {
					  this.indeterminateEC = true
					  this.ecAllSelected = false
          }
        }
			},
			ECToggleAll(checked) {
				this.model.energy_company_id = checked ? this.energycompaniesselect.map(item => {
					return item.id
				}) : []
			},
			// Added by Carlos Rondon 15/02/2019 trucking company
			OAChange() {
					// Additional
					let operating_area   		= this.operatingareasselect
					let operating_area_id   = this.model.operating_areas_id
					if (operating_area_id === true) {
						return


					}
					let ll = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].load_locations.map(o => o.id)
						}
					})

					let ul = operating_area_id.map(item => {
						let oa_index = operating_area.map(o => o.id).indexOf(item)
						if (oa_index > -1) {
							return operating_area[oa_index].unload_locations.map(o => o.id)
						}
					})
					
					let ul_l=[...new Set(Array.prototype.concat.apply([], ul))]
					let ll_l=[...new Set(Array.prototype.concat.apply([], ll))]
					// this.model.load_locations_id = Array.prototype.concat.apply([], ll)
					// this.model.unload_locations_id = Array.prototype.concat.apply([], ul)
					this.model.load_locations_id   = ll_l
					this.model.unload_locations_id = ul_l

				if (this.model.operating_areas_id===null ) {
						return
					}
				if (this.model.operating_areas_id.length === 0) {
					this.indeterminateOA = false
					this.oaAllSelected = false
				} else if (this.model.operating_areas_id.length === this.operatingareasselect.length) {
					this.indeterminateOA = false
					this.oaAllSelected = true
				} else {
					this.indeterminateOA = true
					this.oaAllSelected = false
				}
			},
			LLChange() {
				if (this.model.load_locations_id===null ) {
						this.model.load_locations_id = []
						return
					}	
				if (this.model.load_locations_id.length === 0) {
					this.indeterminateLL = false
					this.llAllSelected = false
				} else if (this.model.load_locations_id.length === this.loadlocationsselect.length) {
					this.indeterminateLL = false
					this.llAllSelected = true
				} else {
					this.indeterminateLL = true
					this.llAllSelected = false
				}
			},
			ULChange() {
				
				if (this.model.unload_locations_id===null) {
						return
					}	
				if (this.model.unload_locations_id.length === 0) {
					this.indeterminateUL = false
					this.ulAllSelected = false
				} else if (this.model.unload_locations_id.length === this.unloadlocationsselect.length) {
					this.indeterminateUL = false
					this.ulAllSelected = true
				} else {
					this.indeterminateUL = true
					this.ulAllSelected = false
				}
			},
			OAToggleAll(checked) {
				this.model.operating_areas_id = checked ? this.operatingareasselect.map(item => {
					return item.id
				}) : []
			},
			LLToggleAll(checked) {
				this.model.load_locations_id = checked ? this.loadlocationsselect.map(item => {
					return item.id
				}) : []
			},
			ULToggleAll(checked) {
				this.model.unload_locations_id = checked ? this.unloadlocationsselect.map(item => {
					return item.id
				}) : []
			},
			allCheckedOA() {
				//return Array(this.model.operating_areas.length).fill(true)
			},
			allCheckedLL() {
				//return Array(this.model.load_locations.length).fill(true)
			},
			allCheckedUL() {
				//return Array(this.model.unload_locations.length).fill(true)
			},
			// End Added
			restoreOriginalData() {
				let model = { ...this.originalData,
					trucking_company_name	: this.originalData.name,
				 	energy_company_id		: [],
					//operating_areas 		: this.operating_areas,
					//operating_areas_id	: [],
					//load_locations			: this.load_locations,
					load_locations_id		: [],
					//unload_locations		: this.unload_locations,
					//unload_locations_id	: []
				}
				this.model = model
			},
			setupFields() {

				if (this.model.energy_companies.length > 0) {
					this.model.energy_company_id = this.model.energy_companies.map(item => {
						return item.id
					})
				} 
				// Added by Carlos Rondon 15/02/2019 trucking company
				if (this.model.load_locations.length > 0) {
					this.model.load_locations_id = this.model.load_locations.map(item => {
						return item.id
					})
				} 
				if (this.model.unload_locations.length > 0) {
					this.model.unload_locations_id = this.model.unload_locations.map(item => {
						return item.id
					})
				} 
				if (this.model.operating_areas.length > 0) {
					this.model.operating_areas_id = this.model.operating_areas.map(item => {
						return item.id
					})
				} 
				//this.model.hazard_id = []
				if (this.model.hazard.length > 0) {
					this.model.hazard_id = this.model.hazard.map(item => {
						return item.hazard_id
					})
				}
				//this.model.control_id = []
				if (this.model.control.length > 0) {
					this.model.control_id = this.model.control.map(item => {
						return item.control_id
					})
				}
				// End Added
			},
			getCompanyData() {

				tc_service.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData 	= data.trucking_company
							this.updateData 	= [] //data.update_data
							this.role 			= data.role
							this.companyId 		= this.id
							this.loadingData 	= false
							this.found 			= true

							this.operating_areas 	= this.originalData.operating_areas
							this.load_locations		= this.originalData.load_locations
							this.unload_locations	= this.originalData.unload_locations


							this.restoreOriginalData()
							this.subTitle 				= this.originalData.name
							this.energycompaniesselect 	= [] //this.updateData.energy_companies

							this.operatingareasselect		= [] //this.updateData.operating_areas_all
							this.loadlocationsselect  		= [] //this.updateData.load_locations_all
							this.unloadlocationsselect  	= [] //this.updateData.unload_locations_all
							this.hazards 			= [] //this.updateData.hazards
							this.controls 			= [] //this.updateData.controls
							this.get_attributtes()
						} else {
							this.$swal(data.status, data.message, data.status)
              				this.loadingData = false
              				return
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.model.trucking_company_name === undefined || this.model.trucking_company_name.trim().length == 0) {
					this.$swal('Alert!', 'Trucking Company Name can not be empty', 'warning')
					return false
				} else if(this.id != localStorage.getItem('xyz')) {
					  this.$swal('Alert!', 'Denegated Access', 'warning')
					  this.$router.push('/trucking_companies')
          			return false
				}
						let m_load_locations_id = this.model.load_locations_id
						let new_ll = []
						m_load_locations_id.forEach(function(e){
							if (e!==undefined) {
								 new_ll.push(e)
							}
						})
						this.model.load_locations_id = new_ll

						let m_unload_locations_id = this.model.unload_locations_id
						let new_ul = []
						m_unload_locations_id.forEach(function(e){
							if (e!==undefined) {
								 new_ul.push(e)
							}
						})
						this.model.unload_locations_id = new_ul
				return true
			},
      		updateTC () {
        		if (!this.okToUpdate()) {
							return
						}

						let file_64 = ''
						if ('file_64' in  localStorage) {
							file_64 = localStorage.getItem('file_64')
						}
						let model = {
							name: this.model.trucking_company_name,
							energy_companies: this.model.energy_company_id.map(item => {
								return {
									id: String(item)
								}
							}),
							operating_areas: this.model.operating_areas_id.map(item => {
								return {
									id: String(item)
								}
							}),
							load_locations: this.model.load_locations_id.map(item => {
								return String(item)
							}),
							unload_locations: this.model.unload_locations_id.map(item => {
								return String(item)
							}),
							load_locations_in: this.load_locations.map(item => {
								return String(item.id)
							}),
							unload_locations_in: this.unload_locations.map(item => {
								return String(item.id)
							}),
							multiloads:this.model.multiloads,
							address         :this.model.address,
							dispatch_title  :this.model.dispatch_title,
							phone_number1   :this.model.phone_number1,
							phone_number2   :this.model.phone_number2,
							alternate_name  :this.model.alternate_name,
							company_logo    :this.model.company_logo,
							in_truck_printing:this.model.in_truck_printing,
							hazard_id				   : this.model.hazard_id,
					  		control_id			   : this.model.control_id,
							file_64            : file_64
						}
						const json = JSON.stringify(model);
        				const blob = new Blob([json], {
          					type: 'application/json'
        				})
        				let formData = new FormData()
        				formData.append("document", blob)
        				formData.append('file', '')
						tc_service.update(this.companyId, formData)
							.then((data) => {
								this.$swal(data[0], data[1], data[0])
								.then((result) => {
									localStorage.removeItem('file_64');
									this.getCompanyData()
								})
						})
						.catch(error => {
							this.$swal('Error', 'Server not response. ' + error, 'error')
						})
	
				//	}
				// })
				this.edit=false
			},
			deleteTC(item) {
				this.$swal({
					title: 'Please Confirm!',
					text: "Are you sure to delete this Trucking Company: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						tc_service.delete(this.companyId)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/trucking_companies')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			arrayUnique(array) {
    			var a = array.concat();
    			for(var i=0; i<a.length; ++i) {
        			for(var j=i+1; j<a.length; ++j) {
            			if(a[i].id === a[j].id)
                			a.splice(j--, 1);
        			}
    			}
    			return a;
			},
			handleFileUpload() {
				this.file = this.$refs.file.files[0]
				this.model.company_logo = this.file['name']
				let url = window.URL.createObjectURL(this.file)
				this.url = url
				setTimeout(() => window.URL.revokeObjectURL(url), 100)
				let reader = new FileReader();

				reader.readAsDataURL(this.file);

				reader.onload = function() {
					localStorage.setItem('file_64', reader.result)      
				return 
				};
			},
			HZChange() {
				if (this.model.hazard_id.length === 0) {
					this.indeterminateHZ = false
					this.hzAllSelected = false
				} else if (this.model.hazard_id.length === this.hazards.length) {
					this.indeterminateHZ = false
					this.hzAllSelected = true
				} else {
					this.indeterminateHZ = true
					this.hzAllSelected = false
				}
			},
			HZToggleAll(checked) {
				this.model.hazard_id = checked ? this.hazards.map(item => {
					return item.id
				}) : []
			},
			CTLChange() {
				if (this.model.control_id.length === 0) {
					this.indeterminateCTL = false
					this.ctlAllSelected = false
				} else if (this.model.control_id.length === this.controls.length) {
					this.indeterminateCTL = false
					this.ctlAllSelected = true
				} else {
					this.indeterminateCTL = true
					this.ctlAllSelected = false
				}
			},
			CTLToggleAll(checked) {
				this.model.control_id = checked ? this.controls.map(item => {
					return item.id
				}) : []
			},
			get_attributtes() {
				tc_service.get_attr(this.id)
					.then(data => {
						if (data.status === 'success') {
							this.updateData 		= data.update_data
							this.hazards 			= this.updateData.hazards
							this.controls 			= this.updateData.controls
							this.energycompaniesselect 	= this.updateData.energy_companies
							this.operatingareasselect		= this.updateData.operating_areas_all
							this.loadlocationsselect  		= this.updateData.load_locations_all
							this.unloadlocationsselect  	= this.updateData.unload_locations_all
						} else {
							this.$swal(data.status, data.message, data.status)
              				this.loadingData = false
              				return
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/trucking_companies/trucking_company.vue